import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Divider,
  IconButton,
  ListSubheader,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarContainer,
  useGridApiContext,
} from "@mui/x-data-grid-pro";
import { useNavigate } from "react-router-dom";
import { CreateFab, SearchButton, SearchFab} from "../components/Buttons";
import { ActionMenu } from "../components/datagrid/ActionMenu";
import {
  AdvancedSearchToolbarProps,
  // GridToolbarExport,
} from "../components/datagrid/AdvancedSearchToolbar";
import { Actions } from "../components/datagrid/DataGrid";
import { DisplayPreferences } from "../components/datagrid/DisplayPreferences";
import { SearchField } from "../components/datagrid/SearchField";
import { GridToolbarExportContainer } from "../components/datagrid/GridToolbarExport";
import { useDataGridStore } from "../store/DataGrid";
import { ListFiltersButton } from "../components/datagrid/AdvancedSearchToolbar";
import { useListingCreateTarget } from "../components/datagrid/ListingRouteBase";
import { StatusQuickFilters } from "../components/datagrid/StatusQuickFilters";

interface DueDateToolbarProps extends AdvancedSearchToolbarProps {
  setFilterButtonEl: React.Dispatch<
    React.SetStateAction<HTMLButtonElement | null>
  >;
  setFilterObj:React.Dispatch<React.SetStateAction<any>>;
}

const GridToolbarExport = ({
  csvOptions,
  printOptions,
  setAction,

  // RESTORED 2026-09-03 (clobbered by 966a1c28) — see
  // components/datagrid/__tests__/SettingsMenuExtrasForks.test.tsx. Destructured
  // here so it does not ride `...other` onto the kebab button's DOM node. The
  // param object is annotated `any` (the idiom certificates/ and freight/
  // already used) so adding a name here cannot make the others required.
  settingsMenuExtras,
  ...other
}: any) => {
  return (
    <>
      <GridToolbarExportContainer {...other}>
        <ListSubheader
          className='list-subheader-item'
        >
          Export
        </ListSubheader>
        <GridCsvExportMenuItem options={csvOptions} />
        <GridPrintExportMenuItem options={printOptions} />
        <Divider />
        <ListSubheader
          className='list-subheader-item'
        >
          Settings
        </ListSubheader>
        <MenuItem
          onClick={() => {
            setAction(Actions.Settings);
          }}
        >
          Display
        </MenuItem>
        {settingsMenuExtras}
      </GridToolbarExportContainer>
    </>
  );
};

export default function DueDateToolbar(props: DueDateToolbarProps) {
  const {
    action,
    actions,
    clearSearch,
    csvOptions,
    defaultItems,
    enableAdvancedSearch,
    enableCreate,
    enableFilter,
    exportState,
    onChange,
    onDelete,
    printOptions,
    quickSearchItems,
    selectionModel,
    setAction,
    setSelected,
    setSelectionModel,
    setFilterButtonEl,
    currentUserId,
    value,
    name,
    setAdvanceSearchClicked,
    setFilterObj,
    // The grid's Default chip field (AeronetDataGrid `quickFilterField`: Department): its
    // Quick Filters row under this toolbar, as the shared list toolbar draws it.
    statusFilter,
    ...other
  } = props;
  let navigate = useNavigate();
  // BP-41: under a mode route (`<base>/list`) a bare "create" would resolve to
  // `<base>/list/create`; the layout declares the base, so this is `<base>/create`.
  const createTarget = useListingCreateTarget();
  const apiRef = useGridApiContext();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const {
    setAdvanceSearchTriggered,
    advanceSearchTriggered,
    setFilterActive,
    filterActive,
    setAdvanceSearch,
    resetQuickFilter
  } = useDataGridStore();

  return (
    <>
      <GridToolbarContainer
        sx={{
          alignItems: "center",
          padding: (theme) => ({
            xs: theme.spacing(2, 1, 2.5),
            md: enableCreate
              ? theme.spacing(5, 6, 2.5, "50px")
              : theme.spacing(5, 6, 2.5, "50px"),
          }),
        }}
        {...other}
      >
        <>
          {selectionModel && selectionModel.length > 0 && onDelete ? (
            <IconButton
              aria-label="delete"
              onClick={() => {
                onDelete(selectionModel);
                setSelectionModel([]);
                for (const rowId of selectionModel) {
                  apiRef.current.updateRows([{ id: rowId, _action: "delete" }]);
                }
              }}
              sx={{
                position: "absolute",
                top: theme.spacing(2.5),
                left: theme.spacing(6.5),
              }}
            >
              <DeleteIcon />
            </IconButton>
          ) : (
            <>
              {enableCreate && (
                <CreateFab
                  onClick={() => {
                    navigate(createTarget);
                  }}
                  size="small"
                ></CreateFab>
              )}
            </>
          )}
          <ActionMenu
            actions={actions}
            setAction={setAction}
            setSelected={setSelected}
            setSelectionModel={setSelectionModel}
          />
          <SearchField
            value={value}
            onChange={onChange}
            clearSearch={clearSearch}
            items={quickSearchItems}
          />
          {enableFilter ? (
            <Box
              onClick={() => {
                setFilterActive(!filterActive);
               if(advanceSearchTriggered){
                  setAdvanceSearchTriggered(false);
                setAdvanceSearchClicked(false)
                setAdvanceSearch(name,[])
                }
              }}
            >
              <ListFiltersButton
                ref={setFilterButtonEl}
                aria-controls="options-menu"
                aria-haspopup="true"
                disableHoverListener = {true}
              />
            </Box>
          ) : (
            <></>
          )}
          <></>
          <Box sx={{ flex: 1 }} />

          <>
            {isSmall ? (
              <>
                {enableAdvancedSearch ? (
                  <SearchFab
                    onClick={() => {
                      props.setAction(Actions.AdvancedSearch);
                    }}
                  />
                ) : null}
              </>
            ) : (
              <>
                {enableAdvancedSearch ? (
                  <>
                    <SearchButton
                      active={advanceSearchTriggered}
                      onClick={() => {
                        props.setAction(Actions.AdvancedSearch);
                        if (!advanceSearchTriggered) {
                          setAdvanceSearchTriggered(true);
                          // setAdvanceSearchClicked(true);
                            resetQuickFilter();
                            setFilterObj(undefined);
                          setFilterActive(false);
                          apiRef.current.setFilterModel(
                            { items: defaultItems },
                            "restoreState"
                          );
                        }
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                <GridToolbarExport
                  csvOptions={csvOptions}
                  printOptions={printOptions}
                  setAction={setAction}
                  {...other}
                />
              </>
            )}
          </>
          {action === Actions.Settings ? (
            <DisplayPreferences
              onSubmit={exportState}
              open={true}
              onClose={() => {
                setAction(Actions.None);
              }}
            />
          ) : (
            <></>
          )}
        </>
      </GridToolbarContainer>
      {enableFilter && <StatusQuickFilters statusFilter={statusFilter} />}
    </>
  );
}
